import PropTypes from "prop-types";

import styles from "./styles.module.css";

const Title = ({ children }) => {
  return <h2 className={styles.title}>{children}</h2>;
};

Title.propTypes = {
  children: PropTypes.node,
};

export default Title;
